import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { I18n } from "@aws-amplify/core";
import { withRouter } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Checkbox from "@material-ui/core/Checkbox";
import Dialog from "@material-ui/core/Dialog";
import { get } from "lodash";

import { roles } from "../../constants/roles";
import { fetchDelete, fetchGet, fetchPost } from "../../api/fetch";
import colors from "../../assets/style/colors";
import images from "../../assets/img/images";
import Add from "./assets/add.svg";
import Barcode from "./assets/mdi_barcode_scan.svg";
import VMIList from "./assets/list_vmi.svg";
import MobileCreateOrderRequest from "./MobileCreateOrderRequest";
import ConfirmOrder from "./ConfirmOrder";
import ScanPopup from "./ScanPopup";
import ProductSearch from "./ProductSearch";
import MobileVmiZones from "./MobileVmiZones";

const styles = {
  mainContent: {
    width: "calc(100vw - 128px)",
    height: "calc(100vh - 200px)",
    minHeight: 0,
    margin: "24px",
    padding: "24px",
  },
  container: {
    height: "40px",
    width: "100%",
    backgroundColor: colors.white,
    paddingLeft: "24px",
    boxShadow: `0px 0px 4px 0px ${colors.black23}`,
  },
  input: {
    backgroundColor: "white",
    width: "349px",
  },
  orderRequestNav: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
  },
  exploreNav: {
    display: "flex",
    alignItems: "center",
  },
  confirmBtn: {
    width: "122px",
    height: "36px",
    backgroundColor: "#5f00a0",
    borderRadius: "2px",
    border: "none",
    color: "white",
    fontWeight: "500",
    boxShadow: "0px 2px 2px #00000033",
  },
  disabledButton: {
    backgroundColor: "#dddddd",
    color: "#00000061",
    userSelect: "none",
    pointerEvents: "none",
  },
  searchBar: {
    marginLeft: "100px",
  },
  orderRequestTable: {
    borderSpacing: "30px",
  },
  tableHeader: {
    display: "grid",
    gridTemplateColumns:
      "60px 38px 360px 125px 80px 80px 270px 150px 144px 144px 170px 170px 125px",
    gridColumnGap: "3px",
    backgroundColor: "white",
    position: "sticky",
    "& th": {
      backgroundColor: "#e5f4f6",
      height: "50px",
      display: "flex",
      alignItems: "center",
      fontWeight: "500",
    },
  },
  tableRow: {
    display: "grid",
    gridTemplateColumns:
      "60px 38px 360px 125px 80px 80px 270px 150px 144px 144px 170px 170px 125px",
    gridColumnGap: "3px",
    borderBottom: "1px solid #dddddd",
    "& th": {
      height: "50px",
    },
    "& td": {
      color: "rgba(0,0,0,0.54)",
      height: "50px",
      boxSizing: "border-box",
      display: "flex",
      alignItems: "center",
    },
  },
  rowBeigeBG: {
    backgroundColor: "#fdf7e9",
  },
  rowPinkBG: {
    backgroundColor: "#FFEEEE",
  },
  tableCheckbox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  selectCheckbox: {
    transform: "scale(1.3)",
  },
  cellCenterIcon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  tableSubtitle: {
    width: "100%",
    padding: "0 12px",
    textAlign: "left",
    boxSizing: "border-box",
  },
  tableSubtitleWarning: {
    color: "red",
  },
  reqTableHead: {
    position: "sticky",
    top: "0",
    zIndex: "20",
  },
  reqTableBody: {
    overflow: "scroll",
  },
  deleteIcon: {
    width: "14px",
    cursor: "pointer",
  },
  inactive: {
    pointerEvents: "none",
  },
  breadcrumbIcon: {
    margin: "0 16px",
  },
  breadcrumbVmi: {
    fontSize: "20px",
    fontWeight: "500",
  },
  blueText: {
    color: "#5f00a0",
    cursor: "pointer",
  },
  grayWarningText: {
    color: "rgba(0,0,0,0.54)",
    fontStyle: "italic",
    marginRight: "16px",
  },
  searchInput: {
    backgroundColor: "white",
    width: "390px",
    height: "36px",
  },
  searchCodeInput: {
    backgroundColor: "white",
    width: "200px",
    height: "36px",
  },
  rowLastOrder: {
    boxSizing: "border-box",
    padding: "0 12px",
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    color: "#eb3c39",
    flexDirection: "column",
  },
  sordId: {
    fontWeight: "400",
  },
  rowLocation: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  selections: {
    display: "flex",
  },
  delete: {
    color: "#eb3c39",
    fontWeight: "500",
    width: "100%",
  },
  deleteItem: {
    cursor: "pointer",
  },
  statusBar: {
    width: "100%",
    height: "24px",
    marginBottom: "6px",
    display: "flex",
    justifyContent: "space-between",
    fontSize: "14px",
  },
  productSelection: {
    display: "grid",
    gridTemplateColumns: "110px 150px 360px 360px",
  },
  statusBarActions: {
    display: "flex",
  },
  deselectLastOrder: {
    color: "#5f00a0",
    cursor: "pointer",
    textAlign: "right",
    gridArea: "1 / 4 / 2 / 5",
  },
  actionButtons: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gridColumnGap: "16px",
  },
  ctaContainer: {
    display: "flex",
    alignItems: "center",
  },
  centerAlignedText: {
    width: "100%",
    textAlign: "center",
  },
  requestButton: {
    cursor: "not-allowed",
    pointerEvents: "none",
  },
  // VMI SEARCH
  orderRequestModal: {
    position: "fixed" /* Stay in place */,
    zIndex: "25" /* Sit on top */,
    left: "300px",
    top: "100px",
    height: "720px",
    width: "420px",
    overflow: "auto" /* Enable scroll if needed */,
    backgroundColor: "rgba(0,0,0,0.4)" /* Black w/ opacity */,
  },
  addProduct: {
    display: "flex",
    alignItems: "center",
    marginLeft: "40px",
    fontSize: "14px",
    fontWeight: "500",
    color: "#5f00a0",
    cursor: "pointer",
    "& img": {
      marginRight: "4px",
    },
  },
  scanProduct: {
    display: "flex",
    alignItems: "center",
    marginLeft: "40px",
    fontSize: "14px",
    fontWeight: "500",
    color: "#5f00a0",
    cursor: "pointer",

    "& img": {
      marginRight: "4px",
    },
  },
  popupHover: {
    display: "inline-block",
    minWidth: "24px",
    height: "24px",
    textAlign: "center",
    padding: "2px 4px 0px",
    "&:hover": {
      borderRadius: "2px",
      cursor: "pointer",
      backgroundColor: "#e5f4f6",
    },
  },
  // MOBILE RESPONSIVE DESIGN
  mobileMain: {
    maxWidth: "478px",
    height: "100%",
    display: "grid",
    gridTemplateColumns: "1fr",
    gridTemplateRows: "72px 60px 1fr 44px",
  },
  mobileUpperBar: {
    width: "100%",
    backgroundColor: "white",
    display: "grid",
    placeItems: "center",
  },
  mobileTitle: {
    fontSize: "14px",
    fontWeight: "500",
  },
  mobileVmiNav: {
    height: "72px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontSize: "18px",
  },
  breadcrumbControl: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  mobileBreadcrumbIcon: {
    marginRight: "8px",
  },
  mobileVmiName: {
    fontSize: "14px",
    maxWidth: "176px",
  },
  mobileControl: {
    width: "80px",
    display: "flex",
    justifyContent: "flex-end",
    "& img": {
      padding: "12px",
    },
  },
  mobileProductSelection: {
    backgroundColor: "white",
    width: "100%",
    borderBottom: "1px solid #dddddd",
    display: "grid",
    gridTemplateColumns: "32px 1fr 48px",
    alignItems: "center",
  },
  mobileTableControl: {
    display: "flex",
    alignItems: "center",
  },
  mobileDelete: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "48px",
    width: "48px",
    marginLeft: "4px",
  },
  mobileRequests: {
    backgroundColor: "white",
    overflowY: "auto",
    maxHeight: "700px",
  },
  mobileCheckboxCol: {
    placeSelf: "center",
  },
  mobileQtyCol: {
    width: "100%",
    boxSizing: "border-box",
    textAlign: "center",
    fontWeight: "500",
    alignSelf: "center",
  },
  mobileQtyColRow: {
    height: "48px",
    width: "48px",
    boxSizing: "border-box",
    textAlign: "center",
    alignSelf: "center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  mobileRow: {
    minHeight: "61px",
    borderBottom: "1px solid #dddddd",
    boxSizing: "border-box",
    display: "grid",
    gridTemplateColumns: "32px 1fr 48px",
  },
  mobileRowCheckbox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
  },
  mobileProductInfo: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
    gridColumnStart: "2",
    gridColumnEnd: "3",
    color: "rgba(0,0,0,0.54)",
  },
  mobileGrayAccentBold: {
    color: "rgba(0,0,0,0.87)",
    fontWeight: "500",
  },
  mobileGrayAccent: {
    color: "rgba(0,0,0,0.87)",
  },
  replenishWarning: {
    color: "#eb3c39",
  },
  mobileConfirmBtn: {
    width: "100%",
    height: "100%",
    borderRadius: "none",
  },
  dialogPaper: {
    width: "100%",
    height: "100%",
    maxHeight: "640px",
    maxWidth: "360px",
    margin: 0,
  },
};

const Requests = (props) => {
  const zoneId = get(props, ["match", "params", "id"]);

  const { history, classes, language } = props;

  const [requests, setRequests] = React.useState([]);
  const [checkedItems, setCheckedItems] = React.useState([]);
  const [checkedCount, setCheckedCount] = React.useState(0);
  const [confirmDialog, setOpenConfirm] = React.useState(false);
  const [searchDialog, setOpenSearch] = React.useState(false);
  const [scanDialog, setOpenScan] = React.useState(false);
  const [editProductDialog, setOpenRequest] = React.useState(false);
  const [zoneDialog, setOpenZone] = React.useState(false);
  const [scanError, setScanError] = React.useState("");
  const [selectedProductData, setSelectedProductData] = React.useState({});
  const [selectedZoneId, setSelectedZoneId] = React.useState({});
  const [sendingRequest, setSendingRequest] = React.useState(false);
  const [vmiName, setVmiName] = React.useState("");
  const [error, setError] = React.useState(false);
  const [checkboxState, setCheckboxState] = React.useState(false);
  const [checkboxStateInd, setCheckboxStateInd] = React.useState(false);

  function getWidth() {
    return Math.max(
      document.body.scrollWidth,
      document.documentElement.scrollWidth,
      document.body.offsetWidth,
      document.documentElement.offsetWidth,
      document.documentElement.clientWidth
    );
  }

  const handleCheckItem = (e, product) => {
    if (e.target.checked) {
      setCheckedCount(checkedCount + 1);

      if (checkedCount + 1 === requests.length) {
        setCheckboxStateInd(false);
        setCheckboxState(true);
      } else {
        setCheckboxStateInd(true);
        setCheckboxState(false);
      }
      setCheckedItems((checkedItems) => [...checkedItems, product]);
      setRequests(
        requests.map((r) => {
          if (product.order_request_id === r.order_request_id) {
            return {
              ...r,
              checked: true,
            };
          } else {
            return r;
          }
        })
      );
    } else {
      setCheckedCount(checkedCount - 1);
      setCheckedItems(checkedItems.filter((p) => p.code !== product.code));
      if (checkedCount - 1 === 0) {
        setCheckboxStateInd(false);
        setCheckboxState(false);
      } else {
        setCheckboxStateInd(true);
        setCheckboxState(false);
      }
      setRequests(
        requests.map((r) => {
          if (product.order_request_id === r.order_request_id) {
            return {
              ...r,
              checked: false,
            };
          } else {
            return r;
          }
        })
      );
    }
  };

  const checkAll = (e) => {
    if (checkedCount === 0) {
      setRequests(
        requests.map((r) => {
          return {
            ...r,
            checked:
              r.customer_po_number && r.customer_po_number.length > 0
                ? true
                : false,
          };
        })
      );
      let okRequests = requests.filter(
        (r) => r.customer_po_number && r.customer_po_number.length > 0
      );
      setCheckedItems(okRequests);
      setCheckedCount(okRequests.length);
      setCheckboxState(okRequests.length === 0 ? false : true);
      setCheckboxStateInd(okRequests.length === requests.length ? false : true);
    } else {
      setRequests(
        requests.map((r) => {
          return { ...r, checked: false };
        })
      );
      setCheckedItems([]);
      setCheckedCount(0);
      setCheckboxState(false);
      setCheckboxStateInd(false);
    }
  };

  const createOrder = () => {
    const body = {
      active: true,
      zone_id: zoneId,
      order_status_id: "a22674f0-8493-463a-a09e-25b5645d7dc7",
      order_request_ids: checkedItems.map((r) => r.order_request_id),
    };

    try {
      setOpenConfirm(true);
      setSendingRequest(true);

      fetchPost("order", body)
        .then((res) => {
          setSendingRequest(false);

          try {
            fetchGet(`order_request_product_details/${zoneId}`)
              .then((orderReq) => {
                setRequests(
                  orderReq.data.map((orderReq) => {
                    return { ...orderReq, checked: false };
                  })
                );
              })
              .catch((e) => console.error(e));
          } catch (e) {
            console.log(e);
          }
        })
        .catch((e) => {
          console.error(e);
          setOpenConfirm(true);
          setError(true);
          try {
            fetchGet(`order_request_product_details/${zoneId}`)
              .then((orderReq) => {
                setRequests(
                  orderReq.data.map((orderReq) => {
                    return { ...orderReq, checked: false };
                  })
                );
                setVmiName(orderReq.vmi_name);
              })
              .catch((e) => console.error(e));
          } catch (e) {
            console.log(e);
          }
        });

      setCheckedItems([]);
      setCheckedCount(0);
    } catch (e) {
      console.log(e);
    }
  };

  const deleteOrderRequests = (id) => {
    const orderRequestIds = id
      ? [id]
      : checkedItems.map((r) => r.order_request_id);
    const body = {
      order_request_ids: orderRequestIds,
    };

    try {
      fetchDelete("order_requests", body)
        .then((res) => {
          fetchGet(`order_request_product_details/${zoneId}`)
            .then((res) => {
              setRequests(
                res.data.map((orderReq) => {
                  return { ...orderReq, checked: false };
                })
              );
              setCheckedItems([]);
              setCheckedCount(0);
            })
            .catch((e) => console.error(e));
        })
        .catch((e) => console.error(e));
    } catch (e) {
      console.log(e);
    }
  };

  const handleScanDialog = (scanId) => {
    if (scanId > 100000) {
      // Scan PZI ID - Order Request Dialog
      const body = {
        description: null,
        code_product: null,
        vendor_name: null,
        ogc: null,
        category: null,
        limit: 10,
        vmi: null,
        codebin: scanId,
        pzitbl: true,
      };

      try {
        fetchPost("products/search", body)
          .then((product) => {
            if (product[0]) {
              if (product[0].order_request_id) {
                fetchGet(`order_request/${product[0].order_request_id}`).then(
                  (orderRequest) => {
                    orderRequest["order_request_id"] = orderRequest["id"];
                    orderRequest["order_request_quantity"] =
                      orderRequest["quantity"];
                    orderRequest["order_request_units"] =
                      orderRequest["unit_of_measurement"];
                    setOpenScan(false);
                    setSelectedProductData({
                      id: product[0].product_id,
                      orderRequest,
                      zoneId: product[0].zone_id,
                      pziId: scanId,
                    });
                    setOpenRequest(true);
                  }
                );
              } else {
                setOpenScan(false);
                setSelectedProductData({
                  id: product[0].product_id,
                  orderRequest: null,
                  zoneId: product[0].zone_id,
                  pziId: scanId,
                });
                setOpenRequest(true);
              }
            } else {
              setScanError(
                I18n.get("profiles_noResultsFound") + " (" + scanId + ")"
              );
              setOpenScan(true);
            }
          })
          .catch((e) => {
            console.error(e);
          });
      } catch (e) {
        console.log(e);
      }
    } else {
      //Scan Zone ID - Zone Navigation Dialog
      setSelectedZoneId(scanId);
      setOpenScan(false);
      setOpenZone(true);
    }
  };

  const generateDate = (date) => {
    const localDate = new Date(date + " UTC");
    return localDate
      .toLocaleString(undefined, {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        hour12: false,
        minute: "2-digit",
        second: "2-digit",
      })
      .replace(/,/g, "");
  };

  const handleBreadcrumbNavigation = (zoneId) => {
    setSelectedZoneId(zoneId);
    setOpenRequest(false);
    setOpenZone(true);
  };

  React.useEffect(() => {
    try {
      fetchGet(`order_request_product_details/${zoneId}`)
        .then((orderReq) => {
          setRequests(
            orderReq.data.map((orderReq) => {
              return { ...orderReq, checked: false };
            })
          );
          setVmiName(orderReq.vmi_name);
        })
        .catch((e) => console.error(e));
    } catch (e) {
      console.log(e);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [zoneId]);

  const level = get(props, ["userRole", "level"]);

  return getWidth() > 478 ? (
    <>
      <Grid
        container
        direction="column"
        wrap="nowrap"
        className={`mainContent ${classes.mainContent}`}
      >
        <Grid item style={{ marginBottom: "24px" }}>
          <Dialog open={confirmDialog}>
            <ConfirmOrder
              handleClose={() => setOpenConfirm(false)}
              error={error}
            ></ConfirmOrder>
          </Dialog>
          <Grid container>
            <Grid item style={{ width: "100%", height: "100%" }}>
              <div className={classes.orderRequestNav}>
                <div className={classes.exploreNav}>
                  <div
                    className={classes.blueText}
                    onClick={() =>
                      history.push(`/wms/requests_orders/requests`)
                    }
                  >
                    {I18n.get("vmi_list").toUpperCase()}
                  </div>{" "}
                  <img
                    src={images.breadcrumbIconBlack}
                    height="12px"
                    alt=">"
                    color={"black"}
                    className={classes.breadcrumbIcon}
                  />{" "}
                  <span className={classes.breadcrumbVmi}>{vmiName}</span>
                  {level <= roles.requester ? (
                    <div
                      className={classes.addProduct}
                      onClick={() => setOpenSearch(true)}
                    >
                      <img src={Add} alt="Add Order Request" />
                      <div>{I18n.get("add_request").toUpperCase()}</div>
                    </div>
                  ) : null}
                  <div
                    className={classes.scanProduct}
                    onClick={() => setOpenScan(true)}
                  >
                    <img src={Barcode} alt="Scan Product" />
                    <div>SCAN</div>
                  </div>
                  <Dialog
                    open={editProductDialog}
                    fullWidth
                    classes={{ paper: classes.dialogPaper }}
                    onBackdropClick={() => setOpenRequest(false)}
                  >
                    <MobileCreateOrderRequest
                      setOpenScan={setOpenScan}
                      setOpenSearch={setOpenSearch}
                      setOpenRequest={setOpenRequest}
                      setRequests={setRequests}
                      setSelectedProductData={setSelectedProductData}
                      vmiId={zoneId}
                      productData={selectedProductData}
                      handleBreadcrumbNavigation={handleBreadcrumbNavigation}
                    />
                  </Dialog>
                  <Dialog
                    open={zoneDialog}
                    fullWidth
                    classes={{ paper: classes.dialogPaper }}
                    onBackdropClick={() => setOpenZone(false)}
                  >
                    <MobileVmiZones
                      setOpenZone={setOpenZone}
                      setOpenRequest={setOpenRequest}
                      setSelectedProductData={setSelectedProductData}
                      setSelectedZoneId={setSelectedZoneId}
                      selectedZoneId={selectedZoneId}
                    />
                  </Dialog>
                  <Dialog
                    open={searchDialog}
                    maxWidth={false}
                    onBackdropClick={() => setOpenSearch(false)}
                  >
                    <ProductSearch
                      style={{ maxWidth: "1400px" }}
                      componentType={"productSearch"}
                      setOpenSearch={setOpenSearch}
                      setRequests={setRequests}
                      setOpenRequest={setOpenRequest}
                      setSelectedProductData={setSelectedProductData}
                      vmiId={zoneId}
                      vmiName={vmiName}
                    />
                  </Dialog>
                  <Dialog
                    open={scanDialog}
                    onBackdropClick={() => setOpenScan(false)}
                  >
                    <ScanPopup
                      setOpenScan={setOpenScan}
                      setSelectedProductData={setSelectedProductData}
                      setSelectedZoneId={setSelectedZoneId}
                      setOpenRequest={setOpenRequest}
                      setOpenZone={setOpenZone}
                      errorMsg={scanError}
                      setScanError={setScanError}
                      handleScanDialog={handleScanDialog}
                    />
                  </Dialog>
                </div>
                <div className={classes.ctaContainer}>
                  {level <= roles.order ? (
                    <button
                      className={`${classes.confirmBtn} ${checkedCount === 0 ? classes.disabledButton : ""
                        } ${sendingRequest ? classes.requestButton : ""}`}
                      onClick={() =>
                        level <= roles.order
                          ? createOrder()
                          : console.log("nope")
                      }
                    >
                      {I18n.get("order_jrv")}
                    </button>
                  ) : null}
                </div>
              </div>
            </Grid>
          </Grid>
        </Grid>
        <div className={classes.grayWarningText}>
          {I18n.get("order_request_warning")}
        </div>
        <div className={classes.statusBar}>
          <div className={classes.productSelection}>
            <div>
              {requests.length}{" "}
              {" " + I18n.get("sidebar_products").toLowerCase()}
            </div>
            <div className={classes.selections}>
              ({checkedCount} {" " + I18n.get("selected_num")})
            </div>
            {checkedCount && level <= roles.order ? (
              <div className={classes.delete}>
                <span
                  className={classes.deleteItem}
                  onClick={() => deleteOrderRequests()}
                >
                  {I18n.get("order_remove").toUpperCase()}
                </span>
              </div>
            ) : null}
          </div>
          <div className={classes.statusBarActions}></div>
        </div>
        <Grid item style={{ overflow: "auto", maxWidth: "1800px" }}>
          <table className={classes.orderRequestTable}>
            <thead className={classes.reqTableHead}>
              <tr className={classes.tableHeader}>
                <th className={classes.tableCheckbox}>
                  {level <= roles.order ? (
                    <Checkbox
                      color="primary"
                      onChange={(e) => checkAll(e)}
                      checked={checkboxState}
                      indeterminate={checkboxStateInd}
                      disabled={requests.length === 0 ? true : false}
                    />
                  ) : null}
                </th>
                <th className={classes.deleteColumn}></th>
                <th className={classes.tableProduct}>
                  <div className={classes.tableSubtitle}>
                    {I18n.get("site_description")}
                  </div>
                </th>
                <th className={classes.tableCode}>
                  <div className={classes.tableSubtitle}>
                    {I18n.get("manufacturer_item_code")}
                  </div>
                </th>
                <th className={classes.tableQuantity}>
                  <div className={classes.tableSubtitle}>
                    {I18n.get("quantity2")}
                  </div>
                </th>
                <th className={classes.tableLastOrder}>
                  <div className={classes.tableSubtitle}>
                    {I18n.get("unit_of_measure")}
                  </div>
                </th>
                <th className={classes.tableLastOrder}>
                  <div className={classes.tableSubtitle}>
                    {I18n.get("pending_order")}
                  </div>
                </th>
                <th className={classes.tableCode}>
                  <div className={classes.tableSubtitle}>
                    {I18n.get("site_po")}
                  </div>
                </th>
                <th className={classes.tableLastOrder}>
                  <div className={classes.tableSubtitle}>
                    {I18n.get("location_vmi")}
                  </div>
                </th>
                <th className={classes.tableVendorName}>
                  <div className={classes.tableSubtitle}>
                    {I18n.get("manufacturer")}
                  </div>
                </th>
                <th className={classes.tableCode}>
                  <div className={classes.tableSubtitle}>
                    {I18n.get("category")}
                  </div>
                </th>
                <th className={classes.tableCreatedOn}>
                  <div className={classes.tableSubtitle}>
                    {I18n.get("events_createdOn")}
                  </div>
                </th>
                <th className={classes.tableCreatedBy}>
                  <div className={classes.tableSubtitle}>
                    {I18n.get("events_createdBy")}
                  </div>
                </th>
              </tr>
            </thead>
            <tbody className={classes.reqTableBody}>
              {requests.map((p, i) => (
                <tr
                  key={`product-${i}`}
                  className={
                    p.customer_po_number && p.customer_po_number.length > 0
                      ? `${classes.tableRow}`
                      : `${classes.tableRow} ${classes.rowPinkBG}`
                  }
                >
                  <td className={classes.cellCenterIcon}>
                    {level <= roles.order ? (
                      <Checkbox
                        color="primary"
                        checked={p.checked}
                        disabled={
                          p.customer_po_number &&
                            p.customer_po_number.length > 0
                            ? false
                            : true
                        }
                        onChange={(e) => handleCheckItem(e, p)}
                      />
                    ) : null}
                  </td>
                  <td className={classes.cellCenterIcon}>
                    {level <= roles.requester ? (
                      <img
                        onClick={() => deleteOrderRequests(p.order_request_id)}
                        src={images.deleteIcon}
                        alt="trash"
                        className={classes.deleteIcon}
                      />
                    ) : null}
                  </td>
                  <td>
                    <div
                      className={`${classes.tableSubtitle}`}
                      title={p.product_attributes_value_item_description}
                    >
                      {p.product_attributes_value_item_description.length > 50
                        ? p.product_attributes_value_item_description.slice(
                          0,
                          50
                        ) + "..."
                        : p.product_attributes_value_item_description}
                    </div>
                  </td>
                  <td>
                    <div className={classes.tableSubtitle}>
                      {p.manufacturer_item_code}
                    </div>
                  </td>
                  <td onClick={() => handleScanDialog(p.pzi_id)}>
                    <div
                      className={`${classes.tableSubtitle} ${classes.blueText}`}
                    >
                      <span className={classes.popupHover}>
                        {p.order_request_quantity}
                      </span>
                    </div>
                  </td>
                  <td>
                    <div className={classes.tableSubtitle}>
                      {p.order_request_base_unit_of_measurement}
                    </div>
                  </td>
                  <td>
                    <div className={classes.rowLastOrder}>
                      <span>
                        {p.sum_quantity
                          ? `${I18n.get("ordered_quantity")}${language === "en" ? ":" : " :"
                          } ${p.sum_quantity}`
                          : null}
                      </span>
                      <span>
                        {p.sum_remaining_quantity
                          ? `${I18n.get("replenishment_outstanding")}${language === "en" ? ":" : " :"
                          } ${p.sum_remaining_quantity}`
                          : null}
                      </span>
                    </div>
                  </td>
                  <td>
                    <div
                      className={
                        p.customer_po_number && p.customer_po_number.length > 0
                          ? `${classes.tableSubtitle}`
                          : `${classes.tableSubtitle} ${classes.tableSubtitleWarning}`
                      }
                      title={p.customer_po_number}
                    >
                      {p.customer_po_number && p.customer_po_number.length > 0
                        ? p.customer_po_number
                        : I18n.get("site_no_po")}
                    </div>
                  </td>
                  <td>
                    <div
                      className={`${classes.tableSubtitle} ${classes.rowLocation}`}
                      title={"Location"}
                    >
                      <span>
                        {p.assigned.split(" > ").slice(1).join(" > ")}
                      </span>
                      <span>({p.pzi_id})</span>
                    </div>
                  </td>
                  <td>
                    <div
                      className={`${classes.tableSubtitle}`}
                      title={p.manufacturer_name}
                    >
                      {p.manufacturer_name.length > 16
                        ? p.manufacturer_name.slice(0, 12) + "..."
                        : p.manufacturer_name}
                    </div>
                  </td>
                  <td>
                    <div
                      className={`${classes.tableSubtitle}`}
                      title={p.product_attributes_value_item_category_name}
                    >
                      {p.product_attributes_value_item_category_name.length > 18
                        ? p.product_attributes_value_item_category_name.slice(
                          0,
                          16
                        ) + "..."
                        : p.product_attributes_value_item_category_name}
                    </div>
                  </td>
                  <td>
                    <div className={classes.tableSubtitle}>
                      {generateDate(p.order_request_created_on)}
                    </div>
                  </td>
                  <td>
                    <div className={classes.tableSubtitle}>
                      {p.users_username}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Grid>
      </Grid>
    </>
  ) : (
    <div className={classes.mobileMain}>
      <div className={classes.mobileVmiNav}>
        <Dialog
          open={editProductDialog}
          fullWidth
          classes={{ paper: classes.dialogPaper }}
        >
          <MobileCreateOrderRequest
            setOpenScan={setOpenScan}
            setOpenSearch={setOpenSearch}
            setOpenRequest={setOpenRequest}
            setRequests={setRequests}
            setSelectedProductData={setSelectedProductData}
            vmiId={zoneId}
            productData={selectedProductData}
            handleBreadcrumbNavigation={handleBreadcrumbNavigation}
          />
        </Dialog>

        <Dialog
          open={scanDialog}
          PaperProps={{
            style: { margin: "0" },
          }}
          onBackdropClick={() => setOpenScan(false)}
        >
          <ScanPopup
            setOpenScan={setOpenScan}
            setSelectedProductData={setSelectedProductData}
            setSelectedZoneId={setSelectedZoneId}
            setOpenRequest={setOpenRequest}
            setOpenZone={setOpenZone}
            errorMsg={scanError}
            setScanError={setScanError}
            handleScanDialog={handleScanDialog}
          />
        </Dialog>
        <Dialog
          open={searchDialog}
          PaperProps={{
            style: { margin: "0", boxSizing: "border-box" },
          }}
          classes={{ paper: classes.dialogPaper }}
        >
          <ProductSearch
            componentType={"productSearch"}
            setOpenSearch={setOpenSearch}
            setRequests={setRequests}
            setOpenRequest={setOpenRequest}
            setSelectedProductData={setSelectedProductData}
            vmiId={zoneId}
            vmiName={vmiName}
          />
        </Dialog>
        <Dialog
          open={zoneDialog}
          fullWidth
          classes={{ paper: classes.dialogPaper }}
          onBackdropClick={() => setOpenZone(false)}
        >
          <MobileVmiZones
            setOpenZone={setOpenZone}
            setOpenRequest={setOpenRequest}
            setSelectedProductData={setSelectedProductData}
            setSelectedZoneId={setSelectedZoneId}
            selectedZoneId={selectedZoneId}
          />
        </Dialog>
        <div className={classes.breadcrumbControl}>
          <div
            className={classes.blueText}
            onClick={() => history.push(`/wms/requests_orders/requests`)}
          >
            <img src={VMIList} alt="VMI List" />
          </div>
          <img
            src={images.breadcrumbIconBlack}
            height="12px"
            alt=">"
            color={"black"}
            className={classes.mobileBreadcrumbIcon}
          />
          <span className={classes.mobileVmiName}>{vmiName}</span>
        </div>
        <div className={classes.mobileControl}>
          <img
            src={Add}
            alt="Add Order Request"
            onClick={() => setOpenSearch(true)}
          />
          <img
            src={Barcode}
            alt="Scan Product"
            onClick={() => setOpenScan(true)}
          />
        </div>
      </div>
      <div className={classes.mobileProductSelection}>
        <div className={classes.mobileCheckboxCol}>
          <Checkbox color="primary" onChange={(e) => checkAll(e)} />
        </div>
        <div className={classes.mobileTableControl}>
          {requests.length} {" " + I18n.get("sidebar_products").toLowerCase()} (
          {checkedCount} {" " + I18n.get("selected_num")})
          <div
            className={classes.mobileDelete}
            onClick={() => deleteOrderRequests()}
          >
            <img
              src={
                checkedCount > 0 ? images.deleteIcon : images.deleteIconInactive
              }
              alt="trash"
              className={`${classes.deleteIcon} ${checkedCount > 0 ? classes.inactive : ""
                }`}
            />
          </div>
        </div>
        <div className={classes.mobileQtyCol}>{I18n.get("qty_abv")}</div>
      </div>
      <div className={classes.mobileRequests}>
        {requests.map((p, i) => (
          <div
            className={
              p.customer_po_number && p.customer_po_number.length > 0
                ? `${classes.mobileRow}`
                : `${classes.mobileRow} ${classes.rowPinkBG}`
            }
            key={`orderRequest-${i}`}
          >
            <div
              className={classes.mobileRowCheckbox}
              onChange={(e) => {
                handleCheckItem(e, p);
              }}
            >
              <Checkbox
                color="primary"
                checked={p.checked}
                disabled={
                  p.customer_po_number && p.customer_po_number.length > 0
                    ? false
                    : true
                }
                onChange={(e) => handleCheckItem(e, p)}
              />
            </div>
            <div className={classes.mobileProductInfo}>
              <div className={classes.mobileGrayAccentBold}>
                {p.product_attributes_value_item_description}
              </div>
              <div>
                <span className={classes.mobileGrayAccent}>
                  {I18n.get("manufacturer_item_code")}
                  {language === "en" ? ":" : " :"}{" "}
                </span>
                {p.product_attribute_value_item_number}
              </div>
              {p.sum_quantity ? (
                <div className={classes.replenishWarning}>{`${I18n.get(
                  "ordered_quantity"
                )}${language === "en" ? ":" : " :"} ${p.sum_quantity}`}</div>
              ) : null}
              {p.sum_remaining_quantity ? (
                <div className={classes.replenishWarning}>{`${I18n.get(
                  "replenishment_outstanding"
                )}${language === "en" ? ":" : " :"} ${p.sum_remaining_quantity
                  }`}</div>
              ) : null}
              <div>
                {p.assigned.split(" > ").slice(1).join(" > ")} ({p.pzi_id})
              </div>
              <div
                className={
                  p.customer_po_number && p.customer_po_number.length > 0
                    ? ""
                    : `${classes.tableSubtitleWarning}`
                }
              >
                {p.customer_po_number && p.customer_po_number.length > 0
                  ? p.customer_po_number
                  : I18n.get("site_no_po")}
              </div>
            </div>
            <div
              className={`${classes.mobileQtyColRow} ${classes.blueText}`}
              onClick={() => handleScanDialog(p.pzi_id)}
            >
              {p.order_request_quantity}
            </div>
          </div>
        ))}
      </div>
      <div className={classes.ctaContainer}>
        <Dialog open={confirmDialog} PaperProps={{ style: { margin: "0" } }}>
          <ConfirmOrder
            handleClose={() => setOpenConfirm(false)}
            error={error}
          ></ConfirmOrder>
        </Dialog>
        {level <= roles.order ? (
          <button
            className={`${classes.confirmBtn} ${classes.mobileConfirmBtn} ${checkedCount === 0 ? classes.disabledButton : ""
              } ${sendingRequest ? classes.requestButton : ""}`}
            onClick={() => createOrder()}
          >
            {I18n.get("order_jrv")}
          </button>
        ) : null}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    language: get(state, ["user", "language"]),
    user: state.user,
    userRole: get(state, ["user", "role"]),
    solutionsAccess: get(state, ["user", "solutionsAccess"]),
    permissions: get(state, ["user", "permissions"]),
  };
};

export default withRouter(
  connect(mapStateToProps)(withStyles(styles)(Requests))
);
